import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CheckEmptySeatFilter from '../components/CheckEmptySeatFilter'
import { getEmptySeats } from '../hooks/events'

export default function EmptySeats() {
    const params = useParams()
    const [emptySeatsEventObj, setEmptySeatsEventObj] = useState(null)
    const navigate = useNavigate()

    const getEventId = async () => {
        const eventId = params.id
        const request = await getEmptySeats(eventId)
        if (request.status === 200) {
            // console.log(request.data)
            request.data.results = request.data.rounds
            request.data.rounds = request.data.rounds.map(e => {
                let obj = { ...e }
                obj.value = e.name
                return obj
            })
            request.data.dates = request.data.dates.map((e) => {
                return { name: dayjs(e).format("DD-MM-YYYY"), value: e }
            })
            request.data.tripTypes = request.data.rounds.map((e) => {
                let name = ""
                if (e.status === 1) name = "ขากลับจากงาน"
                else if (e.status === 2) name = "ขาไปงาน"
                return {
                    name,
                    value: e.status
                }
            }).filter(e => e.name !== "")
            request.data.tripTypes = [...new Set(request.data.tripTypes.map((e) => JSON.stringify(e)))].map((str) => JSON.parse(str)).sort((a, b) => a.value - b.value)
            request.data.rounds = [...new Set(request.data.rounds.map((e) => JSON.stringify(e)))].map((str) => JSON.parse(str)).sort((a, b) => a.value - b.value)
            console.log(request.data)
            setEmptySeatsEventObj(request.data)
        }
    }

    useEffect(() => {
        getEventId()
        // eslint-disable-next-line
    }, [])

    return (
        <div className='container'>
            <br />
            <i className="fa-solid fa-arrow-left" onClick={() => { navigate("/") }}></i>
            <br />
            <h1 align="center">เช็คที่นั่งว่าง</h1>
            <br />
            {emptySeatsEventObj && <div className='card'>
                <div className='card-header'>
                    <h3 align="center">{emptySeatsEventObj.name}</h3>
                </div>
                <div className='card-body'>
                    <CheckEmptySeatFilter
                        emptySeatsEventObj={emptySeatsEventObj}
                        getEventId={getEventId}
                        setEmptySeatsEventObj={setEmptySeatsEventObj}
                    />
                </div>
            </div>}
            <br /><br />
        </div>
    )
}
